import { FEATURE_FLAGS } from 'enums/featureFlags';
import { getFeatureFlagEnabled } from 'utils/useFeatureFlag';

const forcedValue = String(process.env.FORCE_AGENTS_ENTRY_ACCESS_ROUTES || '')
  .trim()
  .toLowerCase();

export function isEntryAccessRoutesAgentsApiEnabled() {
  if (['1', 'true', 'yes', 'on'].includes(forcedValue)) {
    return Promise.resolve(true);
  }

  if (['0', 'false', 'no', 'off'].includes(forcedValue)) {
    return Promise.resolve(false);
  }

  return getFeatureFlagEnabled(
    FEATURE_FLAGS.ENTRY_ACCESS_ROUTES_AGENTS_API_ENABLED,
  );
}
